import { GET_ASSIGN_PROJECTS, GET_ASSIGN_PROJECTS_ERR } from '../../actionTypes/projectType'
import { getAssignProjectsApi } from 'api/Api';
import axios from "axios";
import { accessToken } from 'api/Token'
export const getAssignProjects = (payload) => async (dispatch) => {
    try {
        let results = await axios.get(`${getAssignProjectsApi}/all`, await accessToken())
        let data = results && results.data
        console.log('GET ASSIGN PROJECTS', data)
        dispatch({
            type: GET_ASSIGN_PROJECTS,
            payload: data,
        });
    } catch (error) {
        dispatch({
            type: GET_ASSIGN_PROJECTS_ERR,
            payload: error.response,
        });
    }
};


